import {createElement, PropTypes, PureComponent} from 'rlink-react';
import defaultTracker from 'rlink-telemetry';
import Tracker from 'rlink-telemetry/Tracker';
import ScrollEffect from 'rlink-transitions/ScrollEffect';

export default class TrackViewOnVisible extends PureComponent {
  render () {
    let {name, baseUrl, snapToEdge, tracker} = this.props;
    return <ScrollEffect snapToEdge={snapToEdge} onScroll={scroll => {
      if (scroll.isVisible()) {
        if (!this._wasVisible) {
          tracker.trackView(`${baseUrl || window.location.href}#${name}`);
          this._wasVisible = true;
        }
      } else {
        if (this._wasVisible) {
          this._wasVisible = false;
        }
      }

    }} />;
  }
}

TrackViewOnVisible.defaultProps = {
  tracker: defaultTracker,
};

TrackViewOnVisible.propTypes = {
  name: PropTypes.string,
  baseUrl: PropTypes.string,
  tracker: PropTypes.instanceOf(Tracker),
  snapToEdge: PropTypes.oneOf([
    'top',
    'bottom',
    'left',
    'right',
    'top-left',
    'bottom-left',
    'top-right',
    'bottom-right',
  ]),
};



// WEBPACK FOOTER //
// ./lib/rlink-telemetry/TrackViewOnVisible.jsx